module.exports = __webpack_public_path__ + "static/media/commission_3.8f481b46.svg";